/**
 * V4.36 — Tracking d'usage interne Crédit Flow.
 *
 * Fire-and-forget : ne bloque jamais l'UI, ne fait jamais échouer une action utilisateur.
 * Toutes les erreurs réseau sont silencieusement absorbées.
 *
 * Catalogue d'événements (DOIT être identique au backend `USAGE_EVENT_CATALOG`).
 */
import { api } from "@/lib/api";

export const USAGE_EVENTS = {
  // Commando
  COMMANDO_APPEL: "commando_appel_lance",
  COMMANDO_WHATSAPP: "commando_whatsapp_lance",
  COMMANDO_EMAIL: "commando_email_genere",
  COMMANDO_RELANCE: "commando_relance_traitee",
  COMMANDO_MANDAT_SIGNE: "commando_mandat_signe",
  COMMANDO_BOS_RELANCE: "commando_bos_relance",
  // Dossiers
  DOSSIER_OPEN: "dossier_fiche_open",
  DOSSIER_PHONE_MODIF: "dossier_phone_modifie",
  DOSSIER_EMAIL_MODIF: "dossier_email_modifie",
  DOSSIER_STATUS_CHANGE: "dossier_status_change",
  DOSSIER_ETAPE_CHANGE: "dossier_etape_change",
  // Pilotage
  PILOTAGE_OPEN: "pilotage_page_open",
  PILOTAGE_AUDIT_OPEN: "pilotage_audit_open",
  PILOTAGE_CA_PONDERE: "pilotage_ca_pondere",
  // V4.42 — Briefing stratégique
  BRIEFING_COPIED: "briefing_copied",
};

/**
 * Enregistre un événement d'usage. Fire-and-forget.
 *
 * @param {string} event_type — clé du catalogue (cf. USAGE_EVENTS)
 * @param {object} [opts]
 * @param {string} [opts.dossier_id]
 * @param {string} [opts.etape] — étape métier au moment du clic
 * @param {object} [opts.meta] — payload libre
 */
export function track(event_type, opts = {}) {
  const payload = {
    event_type,
    dossier_id: opts.dossier_id || null,
    etape: opts.etape || null,
    meta: opts.meta || {},
  };
  // fire-and-forget, on .catch silencieux pour ne JAMAIS impacter l'UX
  api.post("/usage/track", payload).catch(() => {});
}

/**
 * Track avec déduplication via localStorage.
 * Utilisé pour les événements à fort risque de pollution (ouverture page = refresh).
 *
 * @param {string} event_type
 * @param {string} dedupKey — clé de déduplication (ex: "pilotage_page_open")
 * @param {number} [ttlMinutes=30] — fenêtre de déduplication
 * @param {object} [opts] — comme track()
 */
export function trackOnce(event_type, dedupKey, ttlMinutes = 30, opts = {}) {
  try {
    const storeKey = `cf:usage:${dedupKey}`;
    const last = localStorage.getItem(storeKey);
    if (last) {
      const ageMin = (Date.now() - parseInt(last, 10)) / 60000;
      if (ageMin < ttlMinutes) return;
    }
    localStorage.setItem(storeKey, String(Date.now()));
  } catch (e) {
    // localStorage indispo → on track de toute façon
    void e;
  }
  track(event_type, opts);
}
